import { useState, useEffect, useCallback, createContext, useContext } from "react"
import * as Requests from "../library/requests/Requests"
import Config from "../library/Config"
import { PresetJson } from "../library/Preset"

const ConfigContext = createContext<Config | null>(null)

export const ConfigProvider = ConfigContext.Provider

export function useConfig(): Config {
  const config = useContext(ConfigContext)
  if (!config) {
    throw new Error("useConfig() called outside of a ConfigProvider")
  }
  return config
}

interface UseConfigResult {
  config: Config | null
  error: string | null
  loading: boolean
}

export function useConfigFetch(code: string): UseConfigResult {
  const [config, setConfig] = useState<Config | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  const updateConfig = useCallback((preset: PresetJson): void => {
    const newConfig = new Config(preset)
    document.body.style.backgroundColor = newConfig.theme.secondaryBackgroundColor

    const urlParams = new URLSearchParams(document.location.search)
    if (urlParams.get("headshots") === "true") {
      newConfig.headshots.showFaceGuide = true
      newConfig.headshots.showTips = true
    }

    setConfig(newConfig)
    setLoading(false)
  }, [])

  useEffect(() => {
    console.log(
      "environment: ",
      process.env.NODE_ENV,
      " is_dev:",
      process.env.REACT_APP_IS_DEV === "true",
    )

    setLoading(true)
    setError(null)

    const presetCode = code.split("-")[0]
    Requests.getPreset(
      presetCode,
      (fetchedPreset: PresetJson) => {
        updateConfig(fetchedPreset)
      },
      (err: string) => {
        document.body.style.backgroundColor = "none"
        setError(err)
        setLoading(false)
      },
    )
  }, [code, updateConfig])

  return { config, error, loading }
}
